import { getDomain } from './../helpers/index';
import store from '../../redux/store';

/**
 * @param  {string} name=''
 * @param  {string} value=''
 * in miliseconds
 * @param  {number} age = defaults to 366 days (the update date for the consent is in the cookie value)
 */

const setCookie = function setCookie(
    value = '',
    name = store.getState().cookieName,
    age = store.getState().cookieExpireTime,
) {
    const now = new Date();
    const time = now.getTime();
    const expireTime = time + age;

    now.setTime(expireTime);
    document.cookie = `${name}=${value};expires=${now.toUTCString()};domain=${getDomain()};`;
};

export default setCookie;